import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_array } from "@swc/helpers/_/_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { useOrganization } from '@core/organization';
import { injectOrganizationId } from '../utilities/injectOrganizationId.js';
// data-remove-listener attribute disables the LinkHandler in app package
export var Link = /*#__PURE__*/ forwardRef(function(_0, _1) {
    var _ref = [
        _0,
        _1
    ], _ref1 = _to_array(_ref), _ref2 = _ref1[0], _rest = _ref1.slice(1), to = _ref2.to, props = _object_without_properties(_ref2, [
        "to"
    ]), _rest1 = _sliced_to_array(_rest, 1), ref = _rest1[0];
    var _useOrganization = useOrganization(), orgId = _useOrganization.id;
    return /*#__PURE__*/ _jsx(ReactRouterLink, _object_spread_props(_object_spread({
        ref: ref
    }, props), {
        to: injectOrganizationId(to, orgId),
        "data-remove-listener": true
    }));
});

//# sourceMappingURL=Link.js.map